import { makeStyles } from 'tss-react/mui';

const useStylesFieldSelect: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  fieldSelect: {
    width: '100%',
    height: 'auto',
    textAlign: 'left',
    '& > div': {
      minHeight: 40,
      margin: 0,
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        fontSize: 14,
        paddingLeft: 10,
        paddingTop: 7,
        paddingBottom: 7,
      },
    },
  },
  fieldSelectNoUnderline: {
    '& > div:before, & > div:after': {
      display: 'none',
    },
  },
  fieldSelectIcon: {
    '& > div > div': {
      flexDirection: 'row',
      alignItems: 'center',
      minHeight: '40px !important',
    },
  },
  fieldSelectLight: {
    '& > div': {
      color: theme.palette.common.white,
      '& > svg': {
        color: `${theme.palette.common.white} !important`,
      },
      '&:after': {
        borderColor: `${theme.palette.common.white} !important`,
      },
    },
  },
  fieldSelectBordered: {
    '& > div': {
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${theme.palette.info.main}`,
    },
  },
  fieldSelectOutlined: {
    '& > div': {
      backgroundColor: theme.palette.background.default,
      '& > div': {
        paddingLeft: 14,
        paddingTop: 16.5,
        paddingBottom: 16.5,
      },
      '&.MuiOutlinedInput-root': {
        '& > fieldset > legend': {
          width: 0,
        },
        '&.Mui-focused > fieldset > legend': {
          width: 'auto',
        },
      },
    },
    '& > label': {
      paddingLeft: 2,
      paddingRight: 2,
      background: theme.palette.common.white,
    },
  },
  fieldSelectOutlinedSelected: {
    '& > div > fieldset > legend': {
      width: 'auto !important',
    },
  },
  fieldSelectRightOffset: {
    marginRight: '20px !important',
  },
  fieldSelectInputPlain: {
    height: 40,
    textAlign: 'left',
    verticalAlign: 'top',
    '& > div': {
      paddingLeft: 15,
      paddingRight: 15,
      '& > em': {
        fontSize: 14,
      },
    },
    '&::before': {
      display: 'none',
    },
  },
  fieldSelectInputPlainOutlined: {
    '& > div': {
      border: 'none',
    },
    '& > label': {
      top: -5,
      zIndex: 1001,
      paddingLeft: 15,
    },
    '& > fieldset': {
      border: `1px solid ${theme.palette.info.main}`,
    },
  },
  fieldSelectInputPlainNoBorders: {
    '& > div': {
      border: 'none !important',
      borderBottom: `1px solid ${theme.palette.info.main}`,
      background: 'none',
    },
  },
  fieldSelectSelect: {
    whiteSpace: 'normal !important',
  },
  fieldSelectSelectNoWrap: {
    whiteSpace: 'nowrap !important',
  },
  fieldSelectShort: {
    width: 150,
  },
}));

export default useStylesFieldSelect;
